import type { FaireProductEntity } from "../../entity_types/product";

export const p_ar6v7butev: FaireProductEntity = {
  token: "p_ar6v7butev",
  type: "product",
  name: "Patchwork Loose Knit Cardigan With Ruffled Sleeves",
  brandToken: "b_n77n5vays8",
  brandName: "kycozy",
  imageUrl:
    "https://cdn.faire.com/fastly/22eef839a41ee49672dc40298170bb4a4b0c3a3d80d60652ed450bf8157bac0a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cd1f477bc668c3db43afa274fc24cc638cf37a51f497cce01f9e85ed980b0419.jpeg",
    "https://cdn.faire.com/fastly/7d968d9bf53c8fd092ee019e18519caa787b510919b7da678abba85187d5a643.jpeg",
    "https://cdn.faire.com/fastly/302b3c653aa7da96627524ff58ff63be8db3a08c8f99a266b3b6cce7f94295cd.jpeg",
    "https://cdn.faire.com/fastly/4d740dd93bc479781ef274aaca20e36f952195dee64eb18a850fa899eed45668.jpeg",
  ],
  priceDollars: 18.49,
  description:
    'Material:Dacron\n\nOccasion:Going out,Casual,Artistic Retro,Girlish Sweetness,Light Maturity,Leisure Fashion\n\nNeckline:V-neck\n\nSeasons:Spring,Autumn\n\nStyle:Loose,Cute,Intellectual,All-match,Look-younger\n\nSleeve Length:Long Sleeve\n\nFeature:Contrast Color\n\nType:Sweater\n\nSleeve Style:Balloon Sleeves\n\nSize S (inch) : Bust= 39.78 ; Sleeve= 18.33 ; Length= 22.62 ; \n\nSize M (inch) : Bust= 41.34 ; Sleeve= 18.72 ; Length= 23.01 ; \n\nSize L (inch) : Bust= 43.68 ; Sleeve= 19.11 ; Length= 23.79 ; \n\nSize XL (inch) : Bust= 46.02 ; Sleeve= 19.50 ; Length= 24.57 ; \n\nAdorable cartoon print short sleeve top & shorts set - loose, cute & all-match Dacron homewear. Features square-neck design for intellectual retro style. Perfect for summer casual wear, leisure fashion & looking younger. Girlish sweetness meets light maturity in this artistic jumpsuit alternative. Great for going out or lounging!" (239 chars) \n\n#Cartoon short sleeve top and shorts set, \n\n#Dacron homewear set, \n\n#Loose cute short sleeve set, \n\n#Intellectual cartoon homewear, \n\n#All-match printing shorts set, \n\n#Look-younger square-neck top, \n\n#Casual artistic retro outfit, \n\n#Girlish sweetness summer wear, \n\n#Light maturity leisure fashion, \n\n#Sleeveless jumpsuits for summer,\n',
  tags: [],
  msrpDollars: 36.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:25.302Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
